import useSWRImmutable from 'swr'
import { swrFetcher } from './helpers'
import { VideoSession } from './aboboApiTypes'

export const useVideoSession = (sessionId:string, attendeeId:string) => {
  const { data: response, error, isLoading } = useSWRImmutable(sessionId && attendeeId ? `/video_sessions/${sessionId}/attendees/${attendeeId}` : null, swrFetcher<VideoSession>)

  return {
    videoSession: response?.data,
    isLoading,
    isError: error
  }
}